import Booked from "./Booked";

export default Booked;
